import { Controller } from "@hotwired/stimulus"
import Choices from 'choices.js';

// Connects to data-controller="creator--bulk-message-form"
export default class extends Controller {
  static targets = [
    "listIdentifiers",
  ]

  connect() {
    this.listIdentifiersTargets.forEach((listIdentifier) => {
      new Choices(listIdentifier, {
        removeItemButton: true,
        multiple: true,
        position: 'bottom',
      });
    });
  }
}
